import { ProjectFeature } from '../model/enums/ProjectFeature';
import { AppLanguage } from '../model/enums/AppLanguage';
import { hasMethodVerification, UseCase } from './useCasesConfig';

// Localization-aware helper: Czech shows Deployment, others hide it; use cases
// without method verification hide Methods. The laboratory handbook has no card:
// it gets the showcase below the cards. Web access is part of the Deployment card.
export const getFeaturesFor = (lang: string, useCase: UseCase): ProjectFeature[] => featuresForLang(lang).filter((feature) => feature !== ProjectFeature.Methods || hasMethodVerification(useCase));

const featuresForLang = (lang: string): ProjectFeature[] => {
  const isCzech = lang?.startsWith('cs');
  if (isCzech) {
    return [
      ProjectFeature.Compliance,
      ProjectFeature.Documentation,
      ProjectFeature.Agendas,
      ProjectFeature.Ai,
      ProjectFeature.Implementation,
      ProjectFeature.Licensing,
      ProjectFeature.AuditReadiness,
      ProjectFeature.Deployment,
    ];
  }

  // Default (en, sk, hu, hr, etc.)
  return [
    ProjectFeature.Compliance,
    ProjectFeature.Documentation,
    ProjectFeature.Methods,
    ProjectFeature.Agendas,
    ProjectFeature.Ai,
    ProjectFeature.Implementation,
    ProjectFeature.Licensing,
    ProjectFeature.Deployment,
  ];
};

const pictureNames: string[] = ['dokumenty', 'schvalovani', 'verifikace', 'pozadavky', 'agendy'];

/** Demo data the hero screenshots are taken on: public/features/<set>/<language>/. */
const SCREENSHOT_SETS: Record<UseCase, string> = {
  clinical: 'clinical',
  transfusion: 'clinical',
  testing: 'testing',
  hospitalQms: 'hospital',
};

const screenshotLanguages: string[] = Object.values(AppLanguage);

/**
 * Screenshots in the hero carousel, in the visitor's language, framed with the
 * DisplayFrame of the slp.blue Design System; method verification only where
 * the use case has it.
 */
export const picturesFor = (useCase: UseCase, lang: string): string[] => {
  const language = screenshotLanguages.find((code) => lang?.startsWith(code)) ?? AppLanguage.English;
  return pictureNames.filter((picture) => picture !== 'verifikace' || hasMethodVerification(useCase)).map((picture) => `/features/${SCREENSHOT_SETS[useCase]}/${language}/${picture}.webp`);
};
